export default __webpack_public_path__ + "static/media/darjeeling1.84dcd126.jpg";